export const environment = {
  production: false,
  apiBaseUrl: window["env"]["API_URL"],
  securityUrl: window["env"]["API_SECURITY_URL"],
  metaMapFlowId: window["env"]["METAMAP_FLOW_ID"],
  application: "QVBQTElDQVRJT05fTUVSQ0FETy1DSEVRVUU=",
  applicationCode: "MERCADO-CHEQUE-PORTAL",
  accessProvider: "MERCADO-CHEQUE-PORTAL",
  platform: "WEB",
  appVersion:'1.2.74'
};
